import { Component, EventEmitter, Input, OnInit, Output, QueryList, ViewChild, ViewChildren, ViewEncapsulation } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators, FormArray } from '@angular/forms';
import { fuseAnimations } from '@fuse/animations';
import { TranslateService } from '@ngx-translate/core';
import { DialogService } from 'app/dialogs/dialog.service';
import { TypeOfGroup } from 'app/enums/types-groups.enum';
import { AlertHistory } from 'app/models/alerts/alert-list.model';
import { CommentsDto } from 'app/models/comment.model';
import { Comments } from 'app/models/complaints/complaint.interface';
import { Item } from 'app/models/item.inferface';
import { UserModel } from 'app/models/user.model';
import { WorkflowStepInstanceSection, workflowStepInstanceSectionLogToSave } from 'app/models/workflow/workflow-step-instance.interface';
import { SimpleFileUploaderComponent } from 'app/modules/simple-file-uploader/simple-file-uploader.component';
import { AuthService } from 'app/services/auth.service';
import { MVLocalStorageService } from 'app/services/mv-local-storage.service';
import { PublicFilesService } from 'app/services/public-files.service';
import { ToastService } from 'app/services/toast.service';

@Component({
  selector: 'app-followup-logs',
  templateUrl: './followup-logs.component.html',
  styleUrls: ['./followup-logs.component.scss'],
  animations: fuseAnimations,
  encapsulation: ViewEncapsulation.None
})
export class FollowupLogsComponent implements OnInit {

  @Input() viewMode = false;
  @Input()
  currentComments: CommentsDto[];
  @Input()
  canRemoveComments: boolean = false;

  @Output()
  commentChanges: EventEmitter<CommentsDto[]> = new EventEmitter();

  @Output()
  deleteCommet: EventEmitter<CommentsDto[]> = new EventEmitter();

  loading = false;

  form: UntypedFormGroup;
  newSectionForm: UntypedFormGroup;
  maxLength = 1024;

  comments: CommentsDto[];
  newHistories = [];
  isMobile = false;
  
  @ViewChild('fileUploader', {static: true})
  private fileUploader: SimpleFileUploaderComponent;
  @ViewChildren(SimpleFileUploaderComponent)
  private fileUploaders: QueryList<SimpleFileUploaderComponent>;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private auth: AuthService,
    private toast: ToastService,
    private fileService: PublicFilesService,
    private dialogService: DialogService,
    private translate: TranslateService,
  ) {
    if(window.innerWidth < 500){
      this.isMobile = true;
    }
  }

  ngOnInit(): void {
    this.form = this.formBuilder.group({
        news: []
      });
  }

  uploadFile() {
    this.fileUploader.openSelectFile();
  }

  addNew() {
    const history: CommentsDto = {
      id: null,
      comment: this.form.get('news').value,
      attachments: this.fileUploader.files,
      createdBy: JSON.parse(MVLocalStorageService.getItem('current_user')).userName,
      createdDate: new Date().toString()
    };

    this.currentComments.push(history);
    this.newHistories.push(history);
    this.form.get('news').setValue('');
    this.fileUploader.rawFiles.map(file => {
      this.fileUploader.removeFile(file);
    });

    this.commentChanges.emit(this.newHistories);
  }

  removeObservation(history){
    let msg = this.translate.instant("FOLLOWUP_ACTIONS.DELETE_COMMENT");
    this.dialogService.openConfirmDialog(msg,null)
    .afterClosed()
    .subscribe(value => {
      if(value){
        if(history.id){
          this.deleteCommet.emit(history);
        }else{
          this.currentComments = this.currentComments.filter(x => x.comment !== history.comment);
          this.newHistories = this.newHistories.filter(x => x.comment !== history.comment);
          this.commentChanges.emit(this.newHistories);
        }
      }
    });
  }

  downloadNewsFiles(file) {
    this.fileService.downloadFileTemplate(file.id).subscribe();
  }

}
